module.exports = __webpack_public_path__ + "src/app/auth/loginPage/loginPhoto.jpg?9bc492f73a882526b30196880904c538";